<div class="position-right" [ngStyle]="{'right': rightValue}">
  <div class="main-container">
    <div class="curve-container">
      <div class="curve curve-1"></div>
      <div class="curve curve-2"></div>
    </div>
    <div class="tabs-container">
      <ul class="nav nav-pills" id="nav-tabs" role="navigation">
        <li routerLinkActive="active">
          <a routerLink="/project">{{'TABS.PROJECT' | anessaTranslation: trigger}}</a>
        </li>
        <li routerLinkActive="active">
          <a routerLink="/results">{{'TABS.RESULTS' | anessaTranslation: trigger}}</a>
        </li>
      </ul>
    </div>
  </div>
</div>
